import {useTranslation} from "react-i18next";
import {useCallback, useEffect, useState} from "react";
import useAnimation from "../../utils/hooks/animate";

import "./Video.css";
import Frame from "./frame";
import {Nav, NavItem, NavLink} from "reactstrap";
import {LocalData, useData, VideoBlockData, videosData} from "../../components/hooks/recoilData";
import {useRecoilState} from "recoil";

export const Video = () => {
    const {i18n, t} = useTranslation();
    useAnimation();
    useEffect(() => {
        document.title = t("title", {name: t("video")});
    }, [t]);
    const [curBlock, setCurBlock] = useState<VideoBlockData>();
    const isRu: boolean = i18n.language === "ru";
    const [, updateVideos] = useData();
    updateVideos();
    const [videos,] = useRecoilState(videosData);

    const getText = useCallback((local: LocalData) => {
        if (!local)
            return "";
        if (isRu && local.ru)
            return local.ru;
        return local.en ? local.en : local.ru;
    }, [isRu]);

    useEffect(() => {
        if (!curBlock && videos && videos.length > 0)
            setCurBlock(videos[0]);
    }, [videos, curBlock]);

    return (
        <main>
            <Nav tabs className="justify-content-center">
                {videos.map((block, id) => (
                    <NavItem key={id}>
                        <NavLink className={`other ${curBlock === block ? "active" : ""}`} onClick={e => setCurBlock(block)}>{getText(block.name)}</NavLink>
                    </NavItem>
                ))}
            </Nav>
            <div>
                {/*<h1 className="text-center header-main animated">{curBlock ? getText(curBlock.name) : ""}</h1>*/}
                {curBlock ? curBlock.content.map((video, id) => (
                    <section key={id}>
                        <p className="text-center animated">{video ? getText(video.name) : ""}</p>
                        <div className="d-flex justify-content-center pt-1">
                            <Frame id={getText(video.url)} title={""} isRutube={isRu}/>
                        </div>

                    </section>
                )) : ""}
            </div>
        </main>
    );
};
